'use client'

import { css, cx } from '@news/styled-system/css'
import { useUnreadPosts } from '@/shared/new-posts-notifier'

export function NewsPostBell({ latestPostPublishedTimeSec }: { latestPostPublishedTimeSec: number }) {
    const hasUnreadPosts = useUnreadPosts(latestPostPublishedTimeSec)

    if (!hasUnreadPosts) {
        return null
    }

    return (
        <span id="news-post-bell">
            &nbsp;
            <i className={cx('fa-solid fa-bell', css({ color: 'primary' }))} />
        </span>
    )
}
